import { useMutation } from "@apollo/client";
import { gql } from "@/gql";

const ACCEPT_INVITATION_MUTATION = gql(`
  mutation AcceptInvitation($token: String!) {
    acceptInvitation(token: $token)
  }
`);

export const useAcceptInvitation = () => {
  const [acceptInvitationMutation, { loading, error }] = useMutation(ACCEPT_INVITATION_MUTATION);

  const acceptInvitation = async (token: string) => {
    const result = await acceptInvitationMutation({
      variables: { token },
    });
    return result.data?.acceptInvitation;
  };

  return {
    acceptInvitation,
    loading,
    error,
  };
};
